// extracted by mini-css-extract-plugin
export default {"th-td":"Table_th-td__hLOXP"};